<template>
  <div>
    <RequestNav title="Active Requests" v-if="$vuetify.breakpoint.smAndDown"/>
    <v-container class="container pa-4">
      <v-row>
        <v-col :key="request.id" cols="12" lg="4" md="6" v-for="request in requests">
          <v-card :to="`/request/${request.slug}`" class="mb-0" hover style="box-shadow: 0 6px 8px rgba(0, 0, 0, .02); border-radius: 10px;">
            <v-card-text class="pa-6 pb-3">
              <div class="d-flex justify-space-between mb-5">
                <div>
                  <v-avatar class="mr-2" color="grey lighten-2" size="26">
                    <v-icon color="blue" size="13">mdi-calendar-month</v-icon>
                  </v-avatar>
                  Total Amount
                </div>
                <div>{{ request.cred_plus_upfront }}</div>
              </div>
              <div class="d-flex justify-space-between mb-5">
                <div>
                  <v-avatar class="mr-2" color="grey lighten-2" size="26">
                    <v-icon color="orange" size="13">mdi-calendar-month</v-icon>
                  </v-avatar>
                  Monthly Repayment
                </div>
                <div>{{ request.monthly_amt }}</div>
              </div>
              <div class="d-flex justify-space-between mb-5">
                <div>
                  <v-avatar class="mr-2" color="grey lighten-2" size="26">
                    <v-icon color="red" size="13">mdi-calendar</v-icon>
                  </v-avatar>
                  Number of months
                </div>
                <div>{{ request.no_of_months }}</div>
              </div>
              <div class="d-flex justify-space-between mb-5">
                <div>
                  <v-avatar class="mr-2" color="grey lighten-2" size="26">
                    <v-icon color="teal" size="13">mdi-tape-measure</v-icon>
                  </v-avatar>
                  Number of items
                </div>
                <div>-</div>
              </div>
              <div class="d-flex justify-space-between mb-7">
                <div>
                  <v-avatar class="mr-2" color="grey lighten-2" size="26">
                    <v-icon color="indigo" size="13">mdi-clock</v-icon>
                  </v-avatar>
                  Date requested
                </div>
                <div>{{ request.req_date | timeago }}</div>
              </div>
              <div class="d-flex mb-10 mt-5">
                <div :key="item.id" class="mr-3" v-for="item in getPreviewItems(request.items)">
                  <ProxyImage
                    :src="item.primary_picture" alt="Item" style="border-radius: 5px; border: 1px solid rgba(0, 0, 0, .1)"
                    width="40"
                  >
                  </ProxyImage>
                </div>
                <div v-if="request.items.length - getPreviewItems(request.items).length > 0">
                  <v-avatar size="40" style="border-radius: 5px; border: 1px solid rgba(0, 0, 0, .1)" tile>
                    {{ request.items.length - getPreviewItems(request.items).length }}+
                  </v-avatar>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
	import RequestNav from "../components/nav/RequestNav";
	import ProxyImage from "../components/ProxyImage";

	export default {
		name: "ActiveRequests",

		components: { ProxyImage, RequestNav },

		data() {
			return {
				loading: false,
				requests: []
			}
		},

		created() {
			this.getRequests();
		},

		methods: {
			async getRequests() {
				const id = this.$store.state.customer.id;
				const res = await this.$http.get(`https://sellbackend.creditclan.com/merchantclanbackend/public/index.php/api/customer/${ id }/all_request`);
				this.requests = res.data.data.reverse();
			},

			getPreviewItems(items) {
				items = JSON.parse(JSON.stringify(items));
				return items.splice(0, 3)
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  .container--fluid {
    margin-top: var(--nav-spacing);
    height: calc((var(--vh, 1vh) * 100) - var(--nav-spacing));
    background: #f5f5f5;
    overflow-y: auto;
  }
</style>
